"use client";

import { useLocale } from "next-intl";
import { formatPrice } from "@/lib/utils";
import { tjsToUsdApproxTens } from "@/lib/format-price-locale";
import { useTjsPerUsd } from "@/components/price/UsdRateProvider";

/** Форматирование цены для публичного UI: en → «с. / ≈ $N», иначе только сомони. */
export function useFormatPrice() {
  const locale = useLocale();
  const tjsPerUsd = useTjsPerUsd();

  return function formatPriceForLocale(amountTjs: number): string {
    const tjs = formatPrice(amountTjs);
    if (locale !== "en" || tjsPerUsd == null) return tjs;
    const usd = tjsToUsdApproxTens(amountTjs, tjsPerUsd);
    if (usd <= 0) return tjs;
    return `${tjs} / ≈ $${usd}`;
  };
}
